import { useTranslation } from 'react-i18next'
import { Wrapper, Button } from './AddContractorDialogButtons.style'

interface AddContractorDialogButtonsProps {
  onCancel: () => void
  isLoading: boolean
  idPrefix: string
  isSubmitDisabled?: boolean
}

const AddContractorDialogButtons = ({
  onCancel,
  isLoading,
  isSubmitDisabled,
  idPrefix,
}: AddContractorDialogButtonsProps) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Button onClick={onCancel} variant="text" id={`${idPrefix}-cancel-btn`}>
        {t('cancel')}
      </Button>
      <Button
        disabled={isSubmitDisabled}
        isLoading={isLoading}
        type="submit"
        variant="contained"
        id={`${idPrefix}-submit-btn`}
      >
        {t('contractor.addContractor')}
      </Button>
    </Wrapper>
  )
}

export default AddContractorDialogButtons
